import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';

let state = {
  currentExport: null,
  currentExportList: null,
  currentExportLayout: null,
  indexPages: 0,
  totalPages: 0,
  globalComment: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
